import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Image, Button, Form, Modal } from 'react-bootstrap';
import InprogressGif from '../../../assets/images/Verification-Gif.gif';
import USA_Flag_Phone from '../../../assets/images/USA_Flag_Phone.png';
import SuccessGif from '../../../assets/images/Success-Gif.gif';
import { convertToBaseFormatMobile } from '../../../commonservices/CommonMethods';
import Modalpopup from '../../Shared/Modals/Modal';

const OnBoardingVerification = (props) => {

    const textD1 = useRef();
    const textD2 = useRef();
    const textD3 = useRef();
    const textD4 = useRef();
    const textD5 = useRef();
    const textD6 = useRef();
    const videoRef = useRef();
    const partnerName = localStorage.getItem('partnerName') ? localStorage.getItem('partnerName') : '';

    const [showModal, setShowModal] = useState(false);
    const [trainingVideoURL, setTrainingVideoURL] = useState('');
    const [verified, setVerified] = useState(false);
    const [validated, setValidated] = useState(false);
    const [otpD1, setOtpD1] = useState('');
    const [otpD2, setOtpD2] = useState('');
    const [otpD3, setOtpD3] = useState('');
    const [otpD4, setOtpD4] = useState('');
    const [otpD5, setOtpD5] = useState('');
    const [otpD6, setOtpD6] = useState('');

    // useEffect(async () => {

    //     const url = await props.getTrainingVideo();
    //     setTrainingVideoURL(url);

    // }, []);

    useEffect(() => {

        if (showModal && videoRef.current)
            videoRef.current.play();
        else if (videoRef.current)
            videoRef.current.pause();

    }, [showModal]);

    const openModal = () => {

        setShowModal(true);

    }

    const closeModal = () => {

        setShowModal(false);

    }

    const setOtpDigits = (currentDigit, value) => {

        if (value && '0123456789'.indexOf(value) === -1) {
            return;
        }

        switch (currentDigit) {

            case 1:
                setOtpD1(value);
                if (value)
                    textD2.current.focus();
                // else
                //     textD1.current.focus();
                break;
            case 2:
                setOtpD2(value);
                if (value)
                    textD3.current.focus();
                // else
                //     textD1.current.focus();
                break;
            case 3:
                setOtpD3(value);
                if (value)
                    textD4.current.focus();
                // else
                //     textD2.current.focus();
                break;
            case 4:
                setOtpD4(value);
                if (value)
                    textD5.current.focus();
                // else
                //     textD3.current.focus();
                break;
            case 5:
                setOtpD5(value);
                if (value)
                    textD6.current.focus();
                // else
                //     textD4.current.focus();
                break;
            case 6:
                setOtpD6(value);
                if (value)
                    textD6.current.focus();
                // else
                //     textD5.current.focus();
                break;
            default:
                break;

        }

    }

    const keyDownHandler = (currentDigit, value, keyCode) => {

        if (keyCode === 8) {

            switch (currentDigit) {

                case 1:
                    textD1.current.focus();
                    break;
                case 2:
                    if (value) {
                        setOtpD2('');
                    }
                    else {
                        setOtpD1('');
                        textD1.current.focus();
                    }
                    break;
                case 3:
                    if (value) {
                        setOtpD3('');
                    }
                    else {
                        setOtpD2('');
                        textD2.current.focus();
                    }
                    break;
                case 4:
                    if (value) {
                        setOtpD4('');
                    }
                    else {
                        setOtpD3('');
                        textD3.current.focus();
                    }
                    break;
                case 5:
                    if (value) {
                        setOtpD5('');
                    }
                    else {
                        setOtpD4('');
                        textD4.current.focus();
                    }
                    break;
                case 6:
                    if (value) {
                        setOtpD6('');
                    }
                    else {
                        setOtpD5('');
                        textD5.current.focus();
                    }
                    break;
                default:
                    break;

            }

        }

    }

    const verifyOTP = async (event) => {

        event.preventDefault();
        event.stopPropagation();
        setValidated(true);

        const form = event.currentTarget;

        if (form.checkValidity() !== false) {

            const otp = otpD1 + otpD2 + otpD3 + otpD4 + otpD5 + otpD6;

            let success = await props.verifyOTP(event, otp);

            if (success) {
                setVerified(true);
                setValidated(false);
            }

        }

    }

    return (
        <div className='dealer-register-verfication'>
            {!verified ?
                <div className="login-page-wrapper">
                    <div className='onboarding-form-box-modal'>
                        <h1 className="mb-4">Verification</h1>
                        <p className='secondary-text-color mb-4'>To make sure that this number is yours, {partnerName} will send you a text message with a six-digit verification code.</p>
                        <b className='mb-3 d-flex align-items-center'><Image src={USA_Flag_Phone} alt="USA Flag Image" fluid /> +1 {convertToBaseFormatMobile(props.phoneNumber)}</b>
                        <Form noValidate
                            validated={validated}
                            onSubmit={(event) => verifyOTP(event)}>
                            <div className='opt-inputs mb-4'>
                                <Form.Control
                                    required
                                    ref={textD1}
                                    type="text"
                                    name="otp1"
                                    minLength={1}
                                    maxLength={1}
                                    value={otpD1}
                                    className="content-text-13px"
                                    placeholder=""
                                    onChange={event => setOtpDigits(1, event.target.value)}
                                    onKeyDown={event => keyDownHandler(1, event.target.value, event.keyCode)}
                                />
                                <Form.Control
                                    required
                                    ref={textD2}
                                    type="text"
                                    name="otp2"
                                    minLength={1}
                                    maxLength={1}
                                    value={otpD2}
                                    className="content-text-13px"
                                    placeholder=""
                                    onChange={event => setOtpDigits(2, event.target.value)}
                                    onKeyDown={event => keyDownHandler(2, event.target.value, event.keyCode)}
                                />
                                <Form.Control
                                    required
                                    ref={textD3}
                                    type="text"
                                    name="otp3"
                                    minLength={1}
                                    maxLength={1}
                                    value={otpD3}
                                    className="content-text-13px"
                                    placeholder=""
                                    onChange={event => setOtpDigits(3, event.target.value)}
                                    onKeyDown={event => keyDownHandler(3, event.target.value, event.keyCode)}
                                />
                                <Form.Control
                                    required
                                    ref={textD4}
                                    type="text"
                                    name="otp4"
                                    minLength={1}
                                    maxLength={1}
                                    value={otpD4}
                                    className="content-text-13px"
                                    placeholder=""
                                    onChange={event => setOtpDigits(4, event.target.value)}
                                    onKeyDown={event => keyDownHandler(4, event.target.value, event.keyCode)}
                                />
                                <Form.Control
                                    required
                                    ref={textD5}
                                    type="text"
                                    name="otp5"
                                    minLength={1}
                                    maxLength={1}
                                    value={otpD5}
                                    className="content-text-13px"
                                    placeholder=""
                                    onChange={event => setOtpDigits(5, event.target.value)}
                                    onKeyDown={event => keyDownHandler(5, event.target.value, event.keyCode)}
                                />
                                <Form.Control
                                    required
                                    ref={textD6}
                                    type="text"
                                    name="otp6"
                                    minLength={1}
                                    maxLength={1}
                                    value={otpD6}
                                    className="content-text-13px"
                                    placeholder=""
                                    onChange={event => setOtpDigits(6, event.target.value)}
                                    onKeyDown={event => keyDownHandler(6, event.target.value, event.keyCode)}
                                />
                                {/* <input required ref={textD1} type='text' minLength={1} maxLength={1} value={otpD1} onChange={event => setOtpDigits(1, event.target.value)} onKeyDown={event => keyDownHandler(1, event.target.value, event.keyCode)} />
                                <input required ref={textD2} type='text' minLength={1} maxLength={1} value={otpD2} onChange={event => setOtpDigits(2, event.target.value)} onKeyDown={event => keyDownHandler(2, event.target.value, event.keyCode)} />
                                <input required ref={textD3} type='text' minLength={1} maxLength={1} value={otpD3} onChange={event => setOtpDigits(3, event.target.value)} onKeyDown={event => keyDownHandler(3, event.target.value, event.keyCode)} />
                                <input required ref={textD4} type='text' minLength={1} maxLength={1} value={otpD4} onChange={event => setOtpDigits(4, event.target.value)} onKeyDown={event => keyDownHandler(4, event.target.value, event.keyCode)} />
                                <input required ref={textD5} type='text' minLength={1} maxLength={1} value={otpD5} onChange={event => setOtpDigits(5, event.target.value)} onKeyDown={event => keyDownHandler(5, event.target.value, event.keyCode)} />
                                <input required ref={textD6} type='text' minLength={1} maxLength={1} value={otpD6} onChange={event => setOtpDigits(6, event.target.value)} onKeyDown={event => keyDownHandler(6, event.target.value, event.keyCode)} /> */}
                            </div>
                            <p className='secondary-text-color mb-1'>Didn’t Receive? <span className="cursor-pointer blue-link-text" onClick={event => props.sendOTP(event)}>Resend OTP</span></p>
                            <b className='mb-1 d-block'>Or</b>
                            <p className='secondary-text-color mb-4'><span className="cursor-pointer blue-link-text" onClick={event => props.sendOTPEmail(event)}>Click here</span> to get the OTP on Email</p>
                            <Button variant='primary' className="default-btn" type="submit">Verify</Button>
                        </Form>
                        {/* <Col md={5}>
                        <Image src={InprogressGif} fluid />
                    </Col> */}
                    </div>
                </div>
                :
                <>
                    <div className='onboarding-form-box-modal'>
                        <h1 className="mb-4">Success</h1>
                        <Row>
                            <Col>
                                <p className='secondary-text-color'>Thank you for registering with {partnerName}! </p>
                                <p className='secondary-text-color'>In order to complete the Dealer on-boarding process please keep the below list of documents ready.</p>
                                <p className='my-3'>You can always log back in at a later time to upload documents if you do not have them now.</p>
                                <ol className='mb-4 secondary-text-color dealerOnboardDocs'>
                                    <li>Drivers license</li>
                                    <li>Business license</li>
                                    <li>Dealership license</li>
                                    <li>Certificate of insurance</li>
                                    <li>Copy of dealer bond</li>
                                    <li>3 months bank statements</li>
                                    <li>All current floorplan receivable reports</li>
                                    <li>Lot photo</li>
                                    <li>Voided check</li>
                                    {props.requestedFacilityAmount > 400000 ?
                                        <>
                                            <li>2 years personal tax return</li>
                                            <li>2 years business tax return</li>
                                            <li>2 years financials</li>
                                            <li>YTD financial statements</li>
                                            <li>Additional documents</li>
                                        </> : null
                                    }
                                </ol>
                                {/* <p className='content-text-15px content-text-color mb-4'>Need help in uploading the documents,<br />
                            <span className="blue-link-text cursor-pointer d-inline-flex align-items-center" onClick={openModal}>Click here <Video size={16} className="ml-1" /></span> for a quick video tutorial</p> */}
                            </Col>
                            {/* <Col md={5}>
                        <Image src={SuccessGif} fluid />
                    </Col> */}
                        </Row>
                    </div>
                    <Button variant='primary' className="default-btn" onClick={event => props.submit(event, null, false, true)}>Next</Button>
                    <Modalpopup myClassName={'lg-popup'} onClose={closeModal} showModal={showModal} showModalFooter={false}>
                        <Modal.Body>
                            <div className='pt-4 pb-2'>
                                <video className='full-width' ref={videoRef} controls>
                                    <source src={trainingVideoURL} />
                                </video>
                            </div>
                        </Modal.Body>
                    </Modalpopup>
                </>}
        </div>
    )

}

export default OnBoardingVerification;